<template>
  <div class="team-box">
    <div class="box" v-if="referees.length > 0">
      <div class="item flex-center" v-for="(item, i) in referees" :key="item.id">
        <p>{{ item.name }} <span v-if="item.refereeLevel">( {{ item.refereeLevel }} )</span></p>
        <!-- <div v-if="item.id === teamsId[0]" class="icon">主队</div>
        <div v-if="item.id === teamsId[1]" class="icon icon2">客队</div> -->
        <div v-if="type === '主裁判'">
          <van-button type="info" :disabled="item.refereeId === refereeFields[0]?.refereeId" color="#1565FC"
            @click="selectReferee(item)">选定</van-button>
        </div>
        <div v-else>
          <van-checkbox v-model="checkedList[i]"></van-checkbox>
        </div>
      </div>
    </div>
    <div v-else
      style="font-size: 18px; color: #333333; font-weight: 500; height: 100px; display: flex; align-items: center; justify-content: center">
      暂无数据
    </div>
    <div class="footer">
      <div class="add" @click="showAdd = true">快速添加裁判</div>
      <div @click="goBack" class="div">确认</div>
    </div>
    <van-popup v-model="showAdd" round position="bottom" closeable>
      <div class="add-form">
        <van-form @submit="addReferee">
          <van-field v-model="form.name" name="name" label="裁判姓名" placeholder="请输入裁判姓名"
            :rules="[{ required: true, message: '裁判姓名不能为空' }]" />
          <van-field name="radio" label="性别" :rules="[{ required: true, message: '请选择性别' }]">
            <template #input>
              <van-radio-group v-model="form.gender" direction="horizontal">
                <van-radio :name="1">男</van-radio>
                <van-radio :name="2">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field v-model="form.mobile" name="mobile" label="联系方式" placeholder="请输入联系方式"
            :rules="[{ required: true, message: '联系方式不能为空' }, { validator: checkMobile, message: '请输入正确的联系电话' }]" />
          <van-field readonly clickable name="bmBirthday" :value="form.bmBirthday" label="出生日期" placeholder="点击选择日期"
            @click="showDay = true" />
          <van-field v-model="match.sportType" name="sportType" disabled label="执裁项目" placeholder="请输入执裁项目" />
          <van-field v-model="form.refereeLevel" name="refereeLevel" label="裁判等级" placeholder="请输入裁判等级" />
          <van-field v-model="form.refereeCardNo" name="refereeCardNo" label="证书编号" placeholder="请输入证书编号" />
          <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit">保存</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
    <van-popup v-model="showDay" round position="bottom">
      <van-datetime-picker :min-date="new Date(1950, 0, 1)" @cancel="showDay = false" @confirm="confirmDay" type="date"
        title="选择年月日" />
    </van-popup>
  </div>
</template>

<script>
import { getUnionMatchRefereeList, createUnionMatchReferee } from '@/api/match'
import Vue from 'vue'
import { Toast, Button, Popup, Form, Field, RadioGroup, Radio, DatetimePicker, Checkbox } from 'vant'
Vue.use(Toast).use(Button).use(Popup).use(Form).use(Field).use(RadioGroup).use(Radio).use(DatetimePicker).use(Checkbox)
import { RegExpr, DateUtil } from '@/utils'

export default {
  data() {
    return {
      unionMatchId: '',
      referees: [],
      type: '主教练', // 0. 主教练  1. 助理教练 2+. 其他
      refereeId: '', // 选中的主教练
      showAdd: false,
      showDay: false,
      form: {},
      match: {},
      refereeFields: [],
      game: {},
      checkedList: [],
      multipleObj: {}
    };
  },
  created() {
    this.unionMatchId = this.$route.query.unionMatchId
    this.type = this.$route.query.type || '主教练'
    this.match = JSON.parse(localStorage.getItem('entry-match')) || {}
    if (this.$store.state.game.refereeFields.length > 0) {
      this.refereeFields = this.$store.state.game.refereeFields
    } else {
      this.refereeFields = [{ refereeId: '', role: this.type, name: '' }]
    }
    if (this.type !== '主裁判') {
      this.multipleObj = { refereeId: '', role: this.type, name: '' }
    }
    this.game = this.$store.state.game
    this.getUnionMatchRefereeList()
  },
  methods: {
    getUnionMatchRefereeList() {
      const params = {
        unionMatchId: this.unionMatchId,
        status: 0,
        pageSize: 99
      }
      getUnionMatchRefereeList(params).then(res => {
        const data = res.data
        this.referees = data.list || []
        const text = this.multipleObj.role // 岗位
        const list = this.$store.state.game.refereeFields
        if (list.length === 0) return
        this.checkedList = data.list.map((item) => {
          if (list.some(ref => ref.refereeId === item.refereeId && ref.role === text)) return true
          return false
        })
      })
    },
    selectReferee(item) {
      this.refereeFields[0].refereeId = item.refereeId
      this.refereeFields[0].name = item.name
    },
    goBack() {
      if (this.type === '主裁判') {
        if (!this.refereeFields[0].refereeId) return Toast('请选择主裁判')
      } else {
        const index = this.refereeFields.findIndex(item => item.role === this.type)
        this.refereeFields = this.refereeFields.filter(item => item.role !== this.multipleObj.role)
        let list = []
        this.checkedList.forEach((item, i) => {
          if (item) {
            const obj = { name: this.referees[i].name, role: this.multipleObj.role, refereeId: this.referees[i].refereeId }
            list.push(obj)
          }
        })
        this.refereeFields.splice(index, 0, ...list)
      }
      const refereeFields = this.refereeFields
      const game = {
        ...this.game,
        refereeFields
      }
      this.$store.dispatch('changeDispatch', game);
      this.$router.back()
    },
    checkMobile(value) {
      return RegExpr.checkMobile(value)
    },
    confirmDay(value) {
      this.form.bmBirthday = DateUtil.parseDateTime(value, '{y}-{m}-{d}')
      this.showDay = false
    },
    addReferee() {
      const params = {
        ...this.form,
        bmBirthday: this.form.bmBirthday + 'T00:00:00+0800',
        unionMatchId: this.unionMatchId,
        accountId: this.match.accountId,
        refereeSportType: this.match.sportType
      }
      createUnionMatchReferee(params).then(res => {
        console.log(res);
        if (res.data) {
          this.getUnionMatchRefereeList()
          Toast('添加成功！')
          this.showAdd = false
        }
      })
    }
  },
};
</script>

<style scoped lang="scss">
.team-box {
  border-top: 12px solid #F6F6F8;
  padding-bottom: 100px;

  .box {
    padding: 16px;

    .item {
      background: #F9FAFC;
      border-radius: 8px;
      margin-bottom: 12px;
      padding: 12px;

      p {
        font-weight: 500;
        flex: 1;

        span {
          margin-left: 12px;
          font-size: 14px;
        }
      }

      ::v-deep .van-button--disabled {
        background-color: #AAAAAA !important;
        border: none;
      }
    }
  }

  .add {
    text-align: center;
    color: #1565FC;
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 12px;
  }

  .add-form {
    padding: 12px;
  }

  .footer {
    position: fixed;
    bottom: 0;
    background-color: #fff;
    width: 100%;
    padding: 16px 12px;

    .div {
      height: 50px;
      background: #1565FC;
      border-radius: 25px;
      color: #fff;
      font-size: 16px;
      text-align: center;
      line-height: 50px;
      width: 351px;
    }
  }
}
</style>
